import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgVitaminCSerumGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M28.035 20.547c-.828-.68-.932-1.362-.932-1.945h1.242v-4.766h-2.173v-3.793C26.172 8.875 25.242 8 24 8c-1.241 0-2.069.875-2.069 2.043v3.793h-2.172v4.863H21c0 .584-.103 1.264-.931 1.945C18.621 21.714 18 22.492 18 24.73v12.936c0 1.653 1.448 2.431 4.241 2.431h3.518c2.793 0 4.241-.778 4.241-2.431V24.632c0-2.237-.517-3.015-1.965-4.085Zm-4.863-10.504c0-.39.414-.779.828-.779s.828.39.828.779v3.793h-1.656v-3.793Zm-2.069 4.96H27v2.432h-5.897v-2.432Zm7.656 22.565c0 .292 0 1.265-3 1.265H22.24c-3 0-3-.876-3-1.265V24.632c0-1.848.414-2.237 1.552-3.112 1.345-.973 1.448-2.14 1.448-2.918h3.414c0 .778.104 1.945 1.448 2.918 1.138.875 1.552 1.264 1.552 3.112v12.936h.104Z",
    fill: "currentColor"
  }));
}

export { SvgVitaminCSerumGlyph as default };
